import React from 'react';
import { FullScreen } from './FullScreen';
import config from '../../config';
import { connect } from 'react-redux';

interface OwnProps{
    url: string
}
function _Welcome({ url }: OwnProps) {
  return <FullScreen logo={url} />;
}

export const Welcome = connect<OwnProps, any, any, Cockpit.Store>(store => ({ url: store.setting.welcomeLogo }))(_Welcome);
